<div class="hc-form-field" [class.hc-form-field--error]="hasError"
     [class.hc-form-field--checkbox]="controlType === 'checkbox'"
     [class.hc-form-field--radio]="controlType === 'radio'">
  <!-- Label row -->
  @if (label) {
    <div class="hc-form-field__header">
      <label class="hc-form-field__label" [attr.for]="fieldId || null">
        {{ label }}
        @if (required) {
          <span class="hc-form-field__required">*</span>
        }
        @if (publishRequired) {
          <lucide-icon name="triangle-alert" class="publish-required-indicator ms-1"></lucide-icon>
        }
      </label>
      @if (optional) {
        <span class="hc-form-field__optional">(Optional)</span>
      }
    </div>
  }

  <!-- Input content slot -->
  <div class="hc-form-field__body">
    <ng-content></ng-content>
  </div>

  <!-- Helper / Error / Char count -->
  <div class="hc-form-field__footer">
    @if (displayError) {
      <p class="hc-form-field__helper hc-form-field__helper--error">{{ displayError }}</p>
    } @else if (helper) {
      <p class="hc-form-field__helper">{{ helper }}</p>
    }
    @if (charMax > 0) {
      <span class="hc-form-field__char-count" [class.hc-form-field__char-count--over]="charCount > charMax">
        {{ charCount }}/{{ charMax }}
      </span>
    }
  </div>
</div>
